import { useQueryClient } from "@tanstack/react-query";
import { del } from "../../api/client";
import { keys } from "../../api/queries";
import type { Tenant } from "../../api/types";
import { PageHead } from "../../app/page-head";
import { errorText } from "../../lib/labels";
import { useNavigate } from "../../router/router";
import { ConfirmButton } from "../../ui/confirm-button";
import { toast } from "../../ui/toaster";

/** Der Kopf des Wizards — mit „Entwurf verwerfen", sobald es einen Entwurf gibt. */
export function WizardHead({ tenant }: { tenant: Tenant | null }) {
  const navigate = useNavigate();
  const client = useQueryClient();
  const discard = async () => {
    if (!tenant) return;
    try {
      await del(`/tenants/${tenant.id}`, { confirm_slug: tenant.slug });
      toast("Entwurf verworfen");
      void client.invalidateQueries({ queryKey: keys.tenants });
      navigate("/tenants");
    } catch (err) { toast(errorText(err), "error"); }
  };
  return (
    <PageHead
      title={tenant ? `Neuer Mandant: ${tenant.name || tenant.slug}` : "Neuer Mandant"}
      hint="Der Wizard schreibt einen Entwurf, keine Infrastruktur — jeder Schritt wird gespeichert, du kannst ihn verlassen und später fortsetzen."
      back={["/tenants", "Mandanten"]}
      actions={tenant ? <ConfirmButton className="pf-btn pf-btn--danger pf-btn--sm" confirmLabel="Wirklich verwerfen?" onConfirm={discard}>Entwurf verwerfen</ConfirmButton> : undefined}
    />
  );
}
